import React from 'react'
import { dataDogInit } from './trackApp'
import { createRoot } from 'react-dom/client'
import App from './containers/Core/App'
import reportWebVitals from './reportWebVitals'

import 'assets/fonts/Canela-Thin.ttf'

dataDogInit()

const container = document.getElementById('root')
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!) // createRoot(container!) if you use TypeScript
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
